import { createFileRoute } from "@tanstack/react-router";
import { UserJoinInfoPage } from "@/pages/user-join-info/ui/user-join-info-page";

const UserJoinInfoRoute = () => {
  return <UserJoinInfoPage />;
};

export const Route = createFileRoute("/_authed/profile")({
  component: UserJoinInfoRoute,
});
